import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { JsonLd, breadcrumbSchema } from './schemas';

export const Breadcrumbs = ({ items }) => {
  const fullItems = [{ label: 'Home', to: '/' }, ...items];
  return (
    <nav aria-label="Breadcrumb" className="bg-gray-50 border-b border-gray-200" data-testid="breadcrumbs-nav">
      <JsonLd data={breadcrumbSchema(fullItems)} />
      <div className="container mx-auto px-4 py-3">
        <ol className="flex items-center gap-2 text-sm flex-wrap">
          {fullItems.map((item, idx) => (
            <li key={item.label} className="flex items-center gap-2">
              {idx > 0 && <ChevronRight className="w-4 h-4 text-gray-400" />}
              {item.to && idx < fullItems.length - 1 ? (
                <Link to={item.to} className="text-gray-600 hover:text-alden-green transition-colors flex items-center gap-1">
                  {idx === 0 && <Home className="w-4 h-4" />}
                  {item.label}
                </Link>
              ) : (
                <span className="text-alden-green font-semibold">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumbs;
